import { convertTradableToFiat, convertFiatToTradable } from "@helpers/tradable-convert";
import { StakingAmountUIModel } from "@modules/staking/domain/entities/staking-amount-selector-state.model";
import { StakingActionType } from "@modules/staking/domain/entities/staking-process.model";
import { TRADABLE_PRECISION } from "@modules/staking/domain/entities/constants";

export function calculatePercentage(percentage: number, state: StakingAmountUIModel): number {
	const calculation = getAvailableToStake(state) * (percentage / 100);
	if (state.displayTradable) {
		return +calculation.toFixed(TRADABLE_PRECISION);
	}
	return +calculation.toFixed(state.defaultFiat.getPrecisionFiat());
}

export function calcExchangeRate(state: StakingAmountUIModel): string {
	return state.displayTradable ? `${getTradableAmount(state, +state.value)}` : `${getFiatValue(state, +state.value)}`;
}

export function getFiatValue(state: StakingAmountUIModel, amountInTradable: number): number {
	return +convertTradableToFiat(state.tradable, amountInTradable, state.defaultFiat).toFixed(
		state.defaultFiat.getPrecisionFiat()
	);
}

export function getTradableAmount(state: StakingAmountUIModel, amountInFiat: number): number {
	return convertFiatToTradable(state.defaultFiat, amountInFiat, state.tradable);
}

export function getAvailableToStake(state: StakingAmountUIModel): number {
	if (state.stakingType === StakingActionType.UNSTAKE) {
		return formatBalance(state.stakedAmountInTradable, state);
	}
	return formatBalance(state.walletBalanceInTradable, state);
}

function formatBalance(balance: number, state: StakingAmountUIModel): number {
	return state.displayTradable ? +balance.toFixed(TRADABLE_PRECISION) : getFiatValue(state, balance);
}

export function findIndexInAmountModelOptions(newValue: string, state: StakingAmountUIModel): number {
	return state.options.findIndex((value: number) => calculatePercentage(value, state) === +newValue);
}
